{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "file:///DateTime.json",
  "title": "DateTime",
  "type": "object",
  "properties": {
    "ts": {
      "type": "number"
    }
  }
}
